/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

import styles from './styles.scss';
import rentToOwnFormApi from '../../api/rentToOwnForm';

function SuccessModal({ onClose }) {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button type="button" className={styles.modalClose} onClick={onClose}>
          ×
        </button>
        <h2 className={styles.modalTitle}>Спасибо! Мы скоро с вами свяжемся</h2>
      </div>
    </div>
  );
}

SuccessModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

const RECEIVE_TYPE_VALUES = {
  TELEGRAM: 'Telegram',
  WHATSAPP: 'WhatsApp',
  MOBILE: 'mobile',
};

const RECEIVE_SWITCHER_VALUES = [
  { value: RECEIVE_TYPE_VALUES.TELEGRAM, label: 'Telegram' },
  { value: RECEIVE_TYPE_VALUES.WHATSAPP, label: 'WhatsApp' },
  { value: RECEIVE_TYPE_VALUES.MOBILE, label: 'Мобильный' },
];

const RECEIVE_CONTACTS_PLACEHOLDERS = {
  [RECEIVE_TYPE_VALUES.TELEGRAM]: '+7 (___) ___-__-__',
  [RECEIVE_TYPE_VALUES.WHATSAPP]: '+7 (___) ___-__-__',
  [RECEIVE_TYPE_VALUES.MOBILE]: '+7 (___) ___-__-__',
};

const FIELD_NAMES = {
  RECEIVE_TYPE: 'receiveType',
  RECEIVE_VALUE: 'receiveValue',
};

function Switcher({ values, initialActiveValue, onChange }) {
  const [activeValue, setActiveValue] = React.useState(
    initialActiveValue || values[0].value,
  );

  const handleClick = value => {
    setActiveValue(value);
    onChange(value);
  };

  return (
    <div className={styles.switcher}>
      {values.map(item => (
        <button
          key={item.value}
          type="button"
          className={classNames(styles.switcherItem, {
            [styles.switcherItemActive]: activeValue === item.value,
          })}
          onClick={() => handleClick(item.value)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}

Switcher.propTypes = {
  initialActiveValue: PropTypes.string,
  values: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

function ReceiveInput({ type, value, placeholder, error, onChange }) {
  const handleChange = event => {
    onChange(event.target.value, type);
  };

  return (
    <div>
      <InputMask
        className={classNames(styles.textarea, {
          [styles.textareaInvalid]: error !== null,
        })}
        mask="+7 (999) 999-99-99"
        type="tel"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
      />
      {error !== null && <p className={styles.formError}>{error}</p>}
    </div>
  );
}

ReceiveInput.propTypes = {
  error: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

class RentToOwnForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      receiveType: RECEIVE_TYPE_VALUES.TELEGRAM,
      receiveValue: {
        [RECEIVE_TYPE_VALUES.TELEGRAM]: '',
        [RECEIVE_TYPE_VALUES.WHATSAPP]: '',
        [RECEIVE_TYPE_VALUES.MOBILE]: '',
      },
      errors: {},
      showErrors: false,
      isSubmitting: false,
      showSuccessModal: false,
    };
  }

  handleTypeChange = value => {
    this.setState({ receiveType: value });
  };

  handleValueChange = (value, type) => {
    this.setState(prevState => ({
      showErrors: false,
      receiveValue: {
        ...prevState.receiveValue,
        [type]: value,
      },
    }));
  };

  validateForm = () => {
    const { receiveType, receiveValue } = this.state;
    const errors = {};

    const phoneValue = receiveValue[receiveType];
    if (!phoneValue || phoneValue.trim() === '' || phoneValue === '+7 (___) ___-__-__') {
      errors[`${FIELD_NAMES.RECEIVE_VALUE}.${receiveType}`] = 'Пожалуйста, введите номер телефона';
    } else {
      const digitsOnly = phoneValue.replace(/\D/g, '');
      if (digitsOnly.length < 11) {
        errors[`${FIELD_NAMES.RECEIVE_VALUE}.${receiveType}`] = 'Введите полный номер телефона';
      }
    }

    return errors;
  };

  handleSubmitClick = () => {
    const { receiveType, receiveValue } = this.state;
    const { adId, rentForMonths, rentToOwnRentPrice, price } = this.props;

    const validationErrors = this.validateForm();

    if (Object.keys(validationErrors).length > 0) {
      this.setState({
        errors: validationErrors,
        showErrors: true,
      });
      return;
    }

    this.setState({ isSubmitting: true });

    const formData = {
      adId,
      rentForMonths: parseInt(rentForMonths, 10),
      rentToOwnRentPrice,
      price,
      receiveType,
      receiveValue,
    };

    rentToOwnFormApi
      .createRentToOwnRequest(formData)
      .then(() => {
        this.setState({
          isSubmitting: false,
          showSuccessModal: true,
        });
      })
      .catch(errors => {
        this.setState({
          isSubmitting: false,
          errors,
          showErrors: true,
        });
      });
  };

  handleModalClose = () => {
    this.setState({ showSuccessModal: false });
    window.location.href = '/';
  };

  render() {
    const {
      receiveType,
      receiveValue,
      errors,
      showErrors,
      isSubmitting,
      showSuccessModal,
    } = this.state;
    const { adId } = this.props;

    const receiveValueError =
      errors[`${FIELD_NAMES.RECEIVE_VALUE}.${receiveType}`];

    return (
      <div className={styles.root}>
        {showSuccessModal && <SuccessModal onClose={this.handleModalClose} />}

        <div className={styles.inner}>
          <h1 className={styles.title}>
            Оставьте свои контакты, мы с вами свяжемся и расскажем более
            подробней как это работает
          </h1>

          <div className={styles.formItemBig}>
            <Switcher
              values={RECEIVE_SWITCHER_VALUES}
              initialActiveValue={receiveType}
              onChange={this.handleTypeChange}
            />
          </div>

          <div className={classNames(styles.field, styles.singleField)}>
            <ReceiveInput
              type={receiveType}
              value={receiveValue[receiveType]}
              placeholder={RECEIVE_CONTACTS_PLACEHOLDERS[receiveType]}
              error={showErrors ? receiveValueError : null}
              onChange={this.handleValueChange}
            />
          </div>
        </div>

        <div className={styles.cta}>
          <div className={styles.buttonWrapper}>
            <button
              className={styles.button}
              type="button"
              disabled={isSubmitting}
              onClick={this.handleSubmitClick}
            >
              {isSubmitting ? 'Отправка...' : 'Продолжить'}
            </button>
          </div>
        </div>

        <div
          className={styles.inner}
          style={{ paddingTop: '40px', borderTop: '1px solid #eee' }}
        >
          <h2 className={classNames(styles.title, styles.titleMb20)}>
            Аренда с правом выкупа (Rent-to-Own)
          </h2>

          <div>
            <p className={styles.text}>
              Вы можете арендовать квартиру и протестировать её перед покупкой.
            </p>
            <p className={styles.text}>Срок аренды — от 3 до 36 месяцев.</p>
            <p className={styles.text}>
              Мы фиксируем цену покупки на момент заключения договора.
            </p>
            <p className={styles.text}>
              Платежи за аренду засчитывается в счёт будущей покупки.
            </p>
          </div>

          <div className={styles.checkList}>
            <div className={styles.checkListItem}>
              Пока вы арендуете квартиру, она может быть доступна для просмотров
              другими покупателями — только по согласованию с вами, в удобное
              для вас время.
            </div>

            <div className={styles.checkListItem}>
              За вами сохраняется преимущественное право на выкуп.
            </div>

            <div className={styles.checkListItem}>
              Передумали покупать — просто съезжаете. Никаких штрафов или
              обязательств.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RentToOwnForm.propTypes = {
  adId: PropTypes.string,
  price: PropTypes.number,
  rentForMonths: PropTypes.number,
  rentToOwnRentPrice: PropTypes.number,
};

export default RentToOwnForm;